import * as types from '../actions';

export default function(state = [], action) {
    const response = action.response;
    switch(action.type) {

        case types.COUNTRY_LIST_SUCCESS:
            if(response.status===200){ 
                let timeVar = '~~'+Date.now(); 
                return {
                    countryList: response.data,
                    countryListStatus: response.status,  
                    countryListActivity:types.COUNTRY_LIST_SUCCESS+timeVar,     
                };
            }
            else {
                return {
                    countryListStatus: response.status,  
                    countryListActivity:types.COUNTRY_LIST_ERROR, 
                    countryListErrorData:response.data                              
                };
            }
        
        case types.COUNTRY_LIST_ERROR:
            return {
                countryListStatus: response.status,  
                countryListActivity:types.COUNTRY_LIST_ERROR, 
                countryListErrorData:response.data                              
            };
        

            
        default:
            return state;
    
        }
    }